import AOS from 'aos';

export function initMarketingMotion() {
  if (window.__routoraInitialMotion) {
    // Initial HTML already initialized AOS with these same settings. Keep
    // its listeners/animation progress, including when navigating onward.
    window.__routoraInitialMotion.refreshHard();
  } else {
    AOS.init({ once: true, disable: 'phone', duration: 700, easing: 'ease-out-cubic' });
  }
}
